import * as React from 'react'

/** Pages between the scans of a stack, in the scan tooltip's header. */
export default ({ direction = 'right', disabled = false }) => (
  <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d={direction === 'left' ? 'M7.5 1L1.5 8L7.5 15' : 'M1.5 1L7.5 8L1.5 15'}
      stroke={disabled ? '#C7CCD9' : '#3C52EF'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
